import AICoachInstagramIdentity from './AICoachInstagramIdentity';

export default AICoachInstagramIdentity;
